import { Environment } from '@app/core/environment';

export const environment: Environment = {
    production: false,
    apiUrl: 'https://tassullo-offertool.staging.zupit.software/api',
    logging: {
        connectionString: '',
        appName: 'frontend',
    },
    auth: {
        redirectUri: 'https://tassullo-offertool.staging.zupit.software',
        issuer: 'https://keycloak.zupit.software/realms/tassullo-offertool-staging',
        clientId: 'oidc',
        showDebugInformation: false,
    },
    version: '',
    clarityProjectId: '',
};
